/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_DeletedInputs */

const vi_grower_area_camera_deleted = /** @type {(inputs: Grower_Area_Camera_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá camera`)
};

/**

* @param {Grower_Area_Camera_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_deleted = /** @type {((inputs?: Grower_Area_Camera_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_deleted(inputs)
});